import { get as idbKvGet, set as idbKvSet, del as idbKvDel } from 'idb-keyval';

import { isIOSDevice } from 'helpers/utils';

import { logIDBSentryError } from './helpers';

/*
 * Minimal Key-Value adapter over IndexedDB
 */

const isIndexedDbAvailable = (): boolean =>
  typeof window !== 'undefined' &&
  typeof document !== 'undefined' &&
  !!window.indexedDB &&
  (isIOSDevice() ? document.visibilityState === 'visible' : true);

const idbGet = async <T = unknown>(key: string): Promise<T | null> => {
  if (!isIndexedDbAvailable()) return null;

  try {
    const v = await idbKvGet<T>(key);
    return v as T;
  } catch (e) {
    logIDBSentryError(e as Error, 'idbGetError');
    return null;
  }
};

const idbSet = async <T = unknown>(key: string, value: T): Promise<void> => {
  if (!isIndexedDbAvailable()) return;

  try {
    await idbKvSet(key, value as any);
  } catch (e) {
    logIDBSentryError(e as Error, 'idbSetError');
  }
};

const idbDel = async (key: string): Promise<void> => {
  if (!isIndexedDbAvailable()) return;

  try {
    await idbKvDel(key);
  } catch (e) {
    logIDBSentryError(e as Error, 'idbDelError');
  }
};

export { idbGet, idbSet, idbDel };
